import React, { useEffect, useState } from 'react';
import { commonServices } from '../../Services/commonServices';
import { Loader } from '../../Components/lotties';
import { commonStyles } from '../../Styles/commonStyles';
import { Box, Container } from '@mui/material';
import { Heading } from '../../Utils/customField';
import { Image } from '../../Utils/imageImport';


const PrivacyPolicy = () => {

    const [privacy, setPrivacy] = useState('');
    const [loader, setLoader] = useState(true);
    const getPrivacyData = async () => {
        
        const res = await commonServices.privacyPolicy();
        if (res?.status === 200) {
            setTimeout(() => {
                setLoader(false);
            }, 500)
            setPrivacy(res?.data?.data?.description);
        }
    }

    useEffect(() => {
        getPrivacyData();
    }, [])
    return (
        <>
            <Box sx={commonStyles.privacyMainDiv}>
                <Container maxWidth="lg">
                    <Box sx={[commonStyles.textCenter, commonStyles.pb1]}>
                        <img src={Image.sideNav_logo} alt="logo" />
                    </Box>
                    <Heading title="Privacy Policy" />
                    {loader ? <Loader /> : <div dangerouslySetInnerHTML={{ __html: privacy }}></div>}
                </Container>
            </Box>
        </>
    )
}

export default PrivacyPolicy
